export default {
    source_migration_title: 'Migración de Origen'
};
